import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Institution18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.35165 1.44607L0.66183 5.33072C0.258599 5.53442 0.126912 6.06569 0.388322 6.43414L1.65684 8.22205C1.80267 8.43003 2.01251 8.59011 2.25 8.6761V15.2501H0V16.7501H18V15.2501H15.75V8.6761C15.9875 8.5901 16.1974 8.43 16.3432 8.222L16.3455 8.21872L17.6117 6.43414C17.8731 6.06569 17.7414 5.53442 17.3382 5.33072L9.64836 1.44607C9.26542 1.19113 8.7346 1.19113 8.35165 1.44607ZM14.25 15.2501V8.75015H11.75V15.2501H14.25ZM10.25 15.2501V8.75015H7.75V15.2501H10.25ZM6.25 15.2501V8.75015H3.75V15.2501H6.25ZM2.11584 6.27674L9.00001 2.79907L15.8842 6.27674L15.1935 7.25015H2.80647L2.11584 6.27674Z'
      fill='currentColor'
    />
  </Svg>
);

Institution18.displayName = 'Institution18';
export default Institution18;
